import {
  Building2,
  Cog,
  Contact,
  LayoutDashboard,
  MapPin,
  ScrollText,
  Landmark,
  Users,
  UsersRound,
  Crosshair,
  FolderOpen,
  XCircle,
  Archive,
  Map,
  TrendingUp,
  type LucideIcon,
} from "lucide-react"
import type { Permissions } from "@/types"

export type NavItem = {
  title: string
  href: string
  icon: LucideIcon
  external?: boolean
  visible?: (permissions: Permissions) => boolean
}

export const mainNavItems: NavItem[] = [
  { title: "Tableau de bord", href: "/", icon: LayoutDashboard },
  { title: "Explorateur", href: "/explore", icon: Map, visible: (p) => p.explore.index },
  { title: "Potentiel", href: "/potentiel-immobilier", icon: TrendingUp },
]

export const projectNavItems: NavItem[] = [
  { title: "Prospects", href: "/prospects", icon: Crosshair },
  { title: "Dossiers", href: "/projects", icon: FolderOpen },
  { title: "Patrimoine", href: "/patrimoine", icon: Building2 },
  { title: "Rejetés", href: "/rejected", icon: XCircle },
  { title: "Archives", href: "/archives", icon: Archive },
]

export const adminNavItems: NavItem[] = [
  {
    title: "Contacts",
    href: "/contacts",
    icon: Contact,
    visible: (p) => p.contacts.index,
  },
  {
    title: "Mon organisation",
    href: "/my_organisation",
    icon: Landmark,
    visible: (p) => p.my_organisation.show,
  },
  {
    title: "Organisations",
    href: "/organisations",
    icon: Building2,
    visible: (p) => p.organisations.index,
  },
  {
    title: "Équipes",
    href: "/teams",
    icon: UsersRound,
    visible: (p) => p.teams.index,
  },
  {
    title: "Utilisateurs",
    href: "/users",
    icon: Users,
    visible: (p) => p.users.index,
  },
  {
    title: "Communes",
    href: "/communes",
    icon: MapPin,
    visible: (p) => p.communes.index,
  },
  {
    title: "Files d'attente",
    href: "/jobs",
    icon: Cog,
    external: true,
    visible: (p) => p.super_admin,
  },
  {
    title: "Événements",
    href: "/res",
    icon: ScrollText,
    external: true,
    visible: (p) => p.super_admin,
  },
]

function filterVisible(items: NavItem[], permissions: Permissions): NavItem[] {
  return items.filter((item) => !item.visible || item.visible(permissions))
}

export function getVisibleNavItems(permissions: Permissions | null): NavItem[] {
  if (!permissions) return []
  return filterVisible(mainNavItems, permissions)
}

export function getVisibleProjectNavItems(permissions: Permissions | null): NavItem[] {
  if (!permissions || !permissions.projects.index) return []
  return projectNavItems
}

export function getVisibleAdminNavItems(permissions: Permissions | null): NavItem[] {
  if (!permissions) return []
  return filterVisible(adminNavItems, permissions)
}
